// extracted by mini-css-extract-plugin
export default {"skeletonBlock":"SkeletonBlock-skeletonBlock-Idl","pulse":"SkeletonBlock-pulse-ahN"};